import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=463a619e&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('463a619e')) {
      api.createRecord('463a619e', component.options)
    } else {
      api.reload('463a619e', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=463a619e&", function () {
      api.rerender('463a619e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UJ7l0j7NZryz/JS/videoIframe.vue"
export default component.exports